import { useState, useEffect } from 'react';
import api from '../../services/api';

export default function AdminEntregas() {
  const [relatorio, setRelatorio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expandido, setExpandido] = useState(null);
  const hoje = new Date().toISOString().slice(0, 10);
  const [inicio, setInicio] = useState(hoje);
  const [fim, setFim] = useState(hoje);

  const carregar = async () => {
    setLoading(true);
    try {
      const r = await api.get(`/entregas/relatorio?inicio=${inicio}&fim=${fim}`);
      setRelatorio(r.data);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { carregar(); }, []);

  const setPeriodo = (dias) => {
    const fimD = new Date();
    const iniD = new Date();
    iniD.setDate(iniD.getDate() - dias);
    setInicio(iniD.toISOString().slice(0, 10));
    setFim(fimD.toISOString().slice(0, 10));
    setTimeout(carregar, 100);
  };

  const fmt = (d) => d ? new Date(d).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '-';

  const inputStyle = {
    background: 'var(--bg4)', border: '1px solid var(--border)',
    color: 'var(--text)', padding: '8px 10px', borderRadius: 6, fontSize: 13
  };

  return (
    <div style={{ padding: 16, maxWidth: 900, margin: '0 auto' }}>
      <h1 style={{ fontSize: 22, fontWeight: 800, marginBottom: 16 }}>🛵 Entregas</h1>

      {/* Filtros de período */}
      <div style={{ background: 'var(--bg3)', padding: 14, borderRadius: 8, marginBottom: 16, border: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
          <button onClick={() => setPeriodo(0)} style={{ ...inputStyle, cursor: 'pointer', background: 'var(--orange)', border: 'none', color: '#fff', fontWeight: 600 }}>Hoje</button>
          <button onClick={() => setPeriodo(7)} style={{ ...inputStyle, cursor: 'pointer' }}>7 dias</button>
          <button onClick={() => setPeriodo(30)} style={{ ...inputStyle, cursor: 'pointer' }}>30 dias</button>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <div>
            <label style={{ fontSize: 11, color: 'var(--text2)', display: 'block' }}>De</label>
            <input type="date" value={inicio} onChange={e => setInicio(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={{ fontSize: 11, color: 'var(--text2)', display: 'block' }}>Até</label>
            <input type="date" value={fim} onChange={e => setFim(e.target.value)} style={inputStyle} />
          </div>
          <button onClick={carregar} style={{
            background: 'var(--orange)', border: 'none', color: '#fff',
            padding: '9px 16px', borderRadius: 6, cursor: 'pointer',
            fontSize: 13, fontWeight: 600, marginTop: 15
          }}>🔍 Consultar</button>
        </div>
      </div>

      {loading ? <div style={{ textAlign: 'center', padding: 40 }}>Carregando...</div>
        : !relatorio ? null
        : (
          <>
            {/* Total geral */}
            <div style={{
              background: 'linear-gradient(135deg, #7c2d12, #431407)',
              padding: 18, borderRadius: 10, marginBottom: 16,
              border: '1px solid #9a3412'
            }}>
              <div style={{ fontSize: 12, color: '#fdba74' }}>💰 Total a pagar aos entregadores</div>
              <div style={{ fontSize: 30, fontWeight: 800, color: '#fff', marginTop: 4 }}>
                R$ {relatorio.total_geral.toFixed(2).replace('.', ',')}
              </div>
              <div style={{ fontSize: 11, color: '#fdba74', marginTop: 4 }}>
                Período: {new Date(relatorio.periodo.inicio + 'T00:00').toLocaleDateString('pt-BR')} até {new Date(relatorio.periodo.fim + 'T00:00').toLocaleDateString('pt-BR')}
              </div>
            </div>

            {relatorio.entregadores.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>
                Nenhuma entrega no período
              </div>
            ) : relatorio.entregadores.map(ent => (
              <div key={ent.entregador_id} style={{
                background: 'var(--bg3)', borderRadius: 8, marginBottom: 10,
                border: '1px solid var(--border)', overflow: 'hidden'
              }}>
                <div onClick={() => setExpandido(expandido === ent.entregador_id ? null : ent.entregador_id)}
                  style={{ padding: 14, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 700 }}>🛵 {ent.entregador_nome}</div>
                    <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>
                      {ent.total_entregas} entrega{ent.total_entregas > 1 ? 's' : ''}
                      {ent.telefone && ` · ${ent.telefone}`}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--orange)' }}>
                      R$ {parseFloat(ent.total_pagar).toFixed(2).replace('.', ',')}
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--text2)' }}>
                      {expandido === ent.entregador_id ? '▲ ocultar' : '▼ ver pedidos'}
                    </div>
                  </div>
                </div>

                {expandido === ent.entregador_id && (
                  <div style={{ borderTop: '1px solid var(--border)', background: 'var(--bg4)' }}>
                    {ent.pedidos.map(p => (
                      <div key={p.id} style={{
                        padding: '10px 14px', borderBottom: '1px solid var(--border)',
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                      }}>
                        <div>
                          <div style={{ fontSize: 13, fontWeight: 600 }}>#{p.id} · {p.cliente_nome}</div>
                          <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 2 }}>{fmt(p.criado_em)} · {p.status}</div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ fontSize: 13, color: '#22c55e', fontWeight: 700 }}>
                            R$ {parseFloat(p.taxa_entregador).toFixed(2).replace('.', ',')}
                          </div>
                          <div style={{ fontSize: 10, color: 'var(--text2)' }}>
                            pedido R$ {parseFloat(p.total).toFixed(2).replace('.', ',')}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </>
        )}
    </div>
  );
}
